var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatrolTermComponent',{attrs:{"typeName":"定期清掃 施工月設定","type":3,"settionStrageName":"FixedPatrolTermStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }